import { Dialog } from "@headlessui/react";
import { FormBox, ModalFoterBox } from "../../../components/box/Box";
import Button from "../../../components/button/Button";
import { Modal, ModalProp } from "../../../components/modal/Modal";
import { useEffect } from "react";
import { SystemSetting } from "../../../model/SystemSetting";
import { useForm } from "react-hook-form";
import InputFile from "../../../components/input/InputFile";
import { PhotoIcon } from "@heroicons/react/24/outline";
import { Label } from "../../../components/fields/Fields";
import FormController from "../../../components/fields/FormController";

export type BgImageSubTitleModalProp = {
  systemSetting?: SystemSetting;
  onSubmit: (data: SystemSetting) => Promise<void>;
  onSendImage: (file: File) => void;
  setBase64Image: React.Dispatch<React.SetStateAction<string>>;
  base64Image?: string;
}

export const BgImageSubTitleModal = ({
  open,
  toggle,
  closeOnClickOutside,
  systemSetting,
  onSubmit,
  onSendImage,
  setBase64Image,
  base64Image
}: ModalProp & BgImageSubTitleModalProp) => {

  const { control, handleSubmit, setValue, reset, } =
    useForm<SystemSetting>({ defaultValues: systemSetting });

  useEffect(() => {
    setValue('subTitle', systemSetting?.subTitle);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[setValue, systemSetting?.subTitle]);

  useEffect(() => {
    reset(systemSetting);
    setBase64Image('');
  },[open, reset, setBase64Image]);

  return (
    <>
      <Modal
        open={open}
        toggle={toggle}
        closeOnClickOutside={closeOnClickOutside}
      >
        <Dialog.Panel className=" relative transform overflow-hidden rounded-lg bg-white  text-left shadow-xl transition-all sm:w-full max-w-screen-md ">
          <form onSubmit={handleSubmit(onSubmit)}>
            <Dialog.Title
              as="h3"
              className="px-4 pt-4 text-left text-lg font-medium leading-6 text-gray-900"
            >
              背景画像とタイトル登録
            </Dialog.Title>
            <Dialog.Description
              className={"px-4 pt-4"}
            >
              横 8 × 縦 3 の比率が推奨画像サイズです。
              <br/>画像は<span className="text-red-500">10MB</span>以下、1ファイルのみです。
              また、画像形式は<span className="text-red-500">JPEG・PNG</span>のみです。
            </Dialog.Description>
            <div className="overflow-y-auto p-4">
              <div className="h-fit max-h-[calc(100vh_-_16rem)]">
                <FormBox gridcol={"grid-cols-1"} className={"items-center"}>
                  <div className={"flex flex-col"}>
                    <Label children={'背景画像'} id={""} />
                    {base64Image === '' || base64Image === undefined
                      ? (<InputFile
                          id={'image'}
                          size={"sm"}
                          color={"indigo"}
                          className={"px-1 items-center w-full h-10"}
                          children={(<>
                            画像ファイル添付
                          </>)}
                          onChange={(e) => {
                            const files = e.target.files;
                            if(files && files[0]){
                              onSendImage(files[0]);
                            }
                          }}
                        />)
                      : (<div className={"flex flex-col items-center space-y-2"}>
                          <img alt={'添付画像'} src={base64Image}/>
                          <Button
                            onClick={() => setBase64Image('')}
                            outline color={'red'}
                            children={'削除'}
                            size={"sm"}
                          />
                        </div>)
                    }
                  </div>
                  <FormController
                    control={control}
                    label={"タイトル"}
                    name={'subTitle'}
                    type={"text"}
                  />
                </FormBox>
              </div>
            </div>
            <ModalFoterBox>
              <Button
                className="mx-2 mt-1 w-[132px]"
                outline
                onClick={toggle}
                children={'キャンセル'}
              />
              <Button
                className="mt-1 mr-2 w-[132px]"
                submit
                children={'登録'}
              />
            </ModalFoterBox>
          </form>
        </Dialog.Panel>
      </Modal>
    </>
  )
}